import React from 'react';
import { CTAButton } from './CTAButton';
import { PRICE_BEFORE, PRICE_NOW } from './salesData';
interface PriceBlockProps {
  /** Etiqueta superior del bloque comercial. */
  eyebrow?: string;
  /** Texto del botón principal. */
  ctaLabel?: string;
  className?: string;
}

/**
 * Bloque comercial reutilizable: qué compra + cuánto cuesta + cómo comprar.
 * El precio usa la sans de interfaz para máxima legibilidad en mobile.
 */
export function PriceBlock({
  eyebrow = 'Mega Pack 6 en 1 + bonos incluidos',
  ctaLabel = 'QUIERO PROFESIONALIZAR MI INSTAGRAM',
  className = ''
}: PriceBlockProps) {
  return <div className={`mx-auto w-full max-w-md rounded-3xl border border-rose/15 bg-white p-5 text-center shadow-lg shadow-indigo-200/40 sm:p-6 ${className}`} data-id="element-166" data-mp="1txa4e60iz3e5">
      <p className="text-[0.7rem] font-bold uppercase tracking-[0.16em] text-rose-deep" data-id="element-167" data-mp="11fo07bp8752p">{eyebrow}</p>

      <div className="mt-2 flex flex-wrap items-end justify-center gap-x-2.5 gap-y-1" data-id="element-168" data-mp="wh4ar1bfbb5l">
        <span className="font-sans text-base font-medium text-ink/40 line-through" data-id="element-169" data-mp="1rzrljuj02r0l">
          {PRICE_BEFORE}
        </span>
        <span className="font-sans text-[2.6rem] font-extrabold leading-none tracking-tight text-ink tabular-nums sm:text-5xl" data-id="element-170" data-mp="1wybb04wsykxp">
          {PRICE_NOW}
        </span>
      </div>

      <p className="mt-2 text-[0.7rem] font-bold uppercase tracking-[0.2em] text-ink/55" data-id="element-171" data-mp="26onzu9bnh09n">
        Pago único
      </p>

      <div className="mt-4 flex justify-center" data-id="element-172" data-mp="191f83wl22uz7">
        <CTAButton label={ctaLabel} data-id="element-173" data-mp="192qgk9pg4qwn" />
      </div>

      <p className="mt-3 text-[0.72rem] font-medium text-ink/60" data-id="element-174" data-mp="1dzgv2sllrefy">
        Acceso inmediato · Pago único · Empezá hoy mismo
      </p>
      <p className="mt-1 text-[0.7rem] text-ink/45" data-id="element-175" data-mp="1ixibt6vk31o9">Producto digital en PDF · Pago seguro</p>
    </div>;
}